/* template */
<template><div class="error-page-box"><mpx-image src="https://ut-static.udache.com/webx/fe-agility-wyc/rpCe2atE5DWBHAPX0uPXF.png" class="empty-icon"></mpx-image><div class="empty-desc">{{errorText}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mbda7909e"}'>
.error-page-box
  position relative
  width 100vw
  height 100vh
  display flex
  flex-direction column
  align-items center
  overflow hidden
  .empty-icon
    margin-top 329rpx
    width 447rpx
    height 323rpx
  .empty-desc
    width 700rpx
    text-align center
    margin-top 40rpx
    font-size 32rpx
    color #000000
    font-weight 500
  .empty-btn
    position absolute
    left auto
    bottom 100rpx
    width 648rpx
    height 100rpx
    background-image linear-gradient(270deg, #FF9042 0%, #FF5304 100%)
    border-radius 12rpx
    font-size 32rpx
    color #FFFFFF
    text-align center
    font-weight 500
    line-height 100rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { setNativeNavBar } from '../../lib/webx/utils/set_native_navbar'
import { EnumNavStyle } from '../../lib/webx/defines'
import { Errno } from '../../lib/webx/api'

createComponent({
  properties: {
    errno: Number,
    useGoodsNotExistError: Boolean,
  },
  computed: {
    errorText() {
      if (this.errno === Errno.GoodsNotExist && this.useGoodsNotExistError) {
        return this.$t('common.notExsitGoodsErrorText')
      }
      if (this.errno === Errno.RequestSetTimeOut) {
        return this.$t('common.netWorkErrorText')
      }
      if (this.errno === Errno.GoodsCanNotBuy) {
        return this.$t('common.cannotBuyGoodsErrorText')
      }
      return this.$t('common.otherRequestErrorText')
    },
  },
  attached() {
    setNativeNavBar({
      navianimated: 1,
      navihidden: 0,
      navstyle: EnumNavStyle.Black,
      titlecolor: '#000000',
      bgcolor: '#FFFFFF',
    })
  },
  ready() {},
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "error-pagebda7909e",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'title-bar':getComponent(require("../../../node_modules/@didi/wyc-components/src/components/title-bar/index.mpx?component=true&componentId=index461bd906")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
